import {AuthorizationProvider} from "@infonova/framework/lib/security/AuthorizationProvider";
import { IntegrationService } from "./IntegrationService";
import { DraftDetails } from "./types/DraftDetails";
import { OfferDetails } from "./types/OfferDetails";
import { OfferDetailsResponse } from "./types/OfferDetailsResponse";

export class IntegrationServiceImpl implements IntegrationService {

    private r6ApiBaseUrl: string;
    private customerAccountListUrl: string;
    private v1url: string;
    private v2url: string;

    constructor(private authorizationProvider: AuthorizationProvider) {
    }

    async assignDraftOrderId(assignOrderUrl: string, draftDetails: DraftDetails) {
        return await this.makeCall(assignOrderUrl, draftDetails);
    }

    async createDraft(draftOrderUrl: string, offerDetails: OfferDetails): Promise<OfferDetailsResponse> {
        return await this.makeCall(draftOrderUrl, offerDetails);
    }

    async makeCall (url: string, body: any) {
        const authorization = await this.authorizationProvider.getAuthorizationInformation();

        const headers = {
            ...authorization.header,
            'Content-Type': 'application/json; charset=UTF-8'
        }
        return fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        }).catch((response) => {
        }).then((response) => {
            if (response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return Promise.reject(response.json());
                }
            }
        });
    }
}